// extracted by mini-css-extract-plugin
export default {"custominput":"styles_custominput__YJ0Gd","custominput__title":"styles_custominput__title__O-Qpd","custominput__input":"styles_custominput__input__Fe+GP"};